// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/quote-tile/quote-tile.component.scss
// module id = 593
// module chunks = 0